function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1972(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 19.68,
    height: 9.91,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.7623076923076924
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 4.955
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.91,
    width: 19.68,
    height: 10.04,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.6733333333333331
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 14.93
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 19.95,
    width: 19.68,
    height: 12.57,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7957142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 26.235
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 32.52,
    width: 19.68,
    height: 13.16,
    style: {
      fill: "#4C0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.645
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 39.1
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 45.68,
    width: 19.68,
    height: 13.65,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.95
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 52.505
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 59.33,
    width: 19.68,
    height: 18.2,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.033333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 68.42999999999999
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 77.54,
    width: 19.68,
    height: 19.46,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.865
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 87.27000000000001
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 97,
    width: 19.68,
    height: 20.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.968
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 107.175
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 117.35,
    width: 19.68,
    height: 21.27,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 127.985
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 138.62,
    width: 19.68,
    height: 21.56,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 149.4
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 160.18,
    width: 19.68,
    height: 22.18,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 171.27
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 182.36,
    width: 19.68,
    height: 22.5,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 193.61
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 204.86,
    width: 19.68,
    height: 24.31,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1866666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 217.01500000000001
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 229.17,
    width: 19.68,
    height: 26.22,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.46
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 242.27999999999997
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 255.39,
    width: 19.68,
    height: 27.86,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.936
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 269.32
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 283.25,
    width: 19.68,
    height: 29.05,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 297.775
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 312.3,
    width: 19.68,
    height: 29.2,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8114285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 326.90000000000003
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 341.5,
    width: 19.68,
    height: 29.5,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8114285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 356.25
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 371,
    width: 19.68,
    height: 29.5,
    style: {
      fill: "#4C0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 385.75
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 400.5,
    width: 19.68,
    height: 29.5,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8114285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 415.25
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 430,
    width: 19.68,
    height: 31.86,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 445.93
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 461.85,
    width: 19.68,
    height: 32.22,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.936
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 477.96000000000004
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 494.07,
    width: 19.68,
    height: 33.05,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.46
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 510.59499999999997
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 527.12,
    width: 19.68,
    height: 33.09,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.46
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 543.665
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 560.21,
    width: 19.68,
    height: 33.73,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8114285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 577.075
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 593.94,
    width: 19.68,
    height: 35.09,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 611.485
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 629.03,
    width: 19.68,
    height: 35.41,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8114285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 646.735
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 664.44,
    width: 19.68,
    height: 35.56,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.936
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.84,
    y: 682.22
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.68,
    y: 0,
    width: 24.91,
    height: 28.2,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.11375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.135,
    y: 14.1
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.59,
    y: 0,
    width: 25.11,
    height: 28.2,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.022
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 57.145,
    y: 14.1
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.69,
    y: 0,
    width: 25.33,
    height: 28.2,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.533
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.35499999999999,
    y: 14.1
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.02,
    y: 0,
    width: 26,
    height: 28.2,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.333333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 108.02,
    y: 14.1
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.02,
    y: 0,
    width: 27.17,
    height: 28.2,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.056666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 134.605,
    y: 14.1
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.19,
    y: 0,
    width: 27.35,
    height: 28.2,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.470000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.865,
    y: 14.1
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.53,
    y: 0,
    width: 27.52,
    height: 28.2,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.88
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.29,
    y: 14.1
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.05,
    y: 0,
    width: 27.63,
    height: 28.2,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.947142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 216.865,
    y: 14.1
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.68,
    y: 0,
    width: 27.89,
    height: 28.2,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.578
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 244.625,
    y: 14.1
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.58,
    y: 0,
    width: 28.56,
    height: 28.2,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 272.85999999999996,
    y: 14.1
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.14,
    y: 0,
    width: 29.13,
    height: 28.2,
    style: {
      fill: "#4C0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 301.705,
    y: 14.1
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316.27,
    y: 0,
    width: 29.33,
    height: 28.2,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 330.935,
    y: 14.1
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 345.6,
    y: 0,
    width: 30.24,
    height: 28.2,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.82
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 360.72,
    y: 14.1
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.84,
    y: 0,
    width: 30.28,
    height: 28.2,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.97999999999996,
    y: 14.1
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406.12,
    y: 0,
    width: 31.07,
    height: 28.2,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 421.65500000000003,
    y: 14.1
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 437.19,
    y: 0,
    width: 32.03,
    height: 28.2,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.82
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 453.205,
    y: 14.1
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 469.23,
    y: 0,
    width: 32.32,
    height: 28.2,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 485.39000000000004,
    y: 14.1
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501.55,
    y: 0,
    width: 32.44,
    height: 28.2,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 517.77,
    y: 14.1
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 533.98,
    y: 0,
    width: 32.64,
    height: 28.2,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 550.3000000000001,
    y: 14.1
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 566.62,
    y: 0,
    width: 33.04,
    height: 28.2,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 583.14,
    y: 14.1
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 599.67,
    y: 0,
    width: 33.4,
    height: 28.2,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 616.37,
    y: 14.1
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 633.07,
    y: 0,
    width: 33.43,
    height: 28.2,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.0285714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 649.7850000000001,
    y: 14.1
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 666.5,
    y: 0,
    width: 33.5,
    height: 28.2,
    style: {
      fill: "#4C0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.05
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 683.25,
    y: 14.1
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.68,
    y: 28.2,
    width: 32.37,
    height: 31.04,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.88
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.864999999999995,
    y: 43.72
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.68,
    y: 59.24,
    width: 32.37,
    height: 31.16,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.451428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.864999999999995,
    y: 74.82000000000001
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.68,
    y: 90.4,
    width: 32.37,
    height: 31.76,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.97
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.864999999999995,
    y: 106.28
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.68,
    y: 122.16,
    width: 32.37,
    height: 32.01,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.864999999999995,
    y: 138.165
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.68,
    y: 154.17,
    width: 32.37,
    height: 32.23,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.371666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.864999999999995,
    y: 170.285
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.68,
    y: 186.4,
    width: 32.37,
    height: 32.24,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.448
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.864999999999995,
    y: 202.52
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.68,
    y: 218.65,
    width: 32.37,
    height: 32.45,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.473999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.864999999999995,
    y: 234.875
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.68,
    y: 251.1,
    width: 32.37,
    height: 33.06,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.395
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.864999999999995,
    y: 267.63
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.68,
    y: 284.15,
    width: 32.37,
    height: 33.19,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.395
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.864999999999995,
    y: 300.745
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.68,
    y: 317.34,
    width: 32.37,
    height: 33.59,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.395
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.864999999999995,
    y: 334.135
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.68,
    y: 350.93,
    width: 32.37,
    height: 33.85,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.624285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.864999999999995,
    y: 367.855
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.68,
    y: 384.77,
    width: 32.37,
    height: 33.88,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.624285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.864999999999995,
    y: 401.71
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.68,
    y: 418.66,
    width: 32.37,
    height: 34.34,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.624285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.864999999999995,
    y: 435.83000000000004
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.68,
    y: 452.99,
    width: 32.37,
    height: 34.39,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.0925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.864999999999995,
    y: 470.185
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.68,
    y: 487.38,
    width: 32.37,
    height: 34.58,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.395
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.864999999999995,
    y: 504.67
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.68,
    y: 521.97,
    width: 32.37,
    height: 34.71,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.04625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.864999999999995,
    y: 539.325
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.68,
    y: 556.68,
    width: 32.37,
    height: 34.84,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.473999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.864999999999995,
    y: 574.0999999999999
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.68,
    y: 591.52,
    width: 32.37,
    height: 35.46,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.624285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.864999999999995,
    y: 609.25
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.68,
    y: 626.98,
    width: 32.37,
    height: 36.29,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.04625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.864999999999995,
    y: 645.125
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.68,
    y: 663.27,
    width: 32.37,
    height: 36.73,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.395
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 35.864999999999995,
    y: 681.635
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.04,
    y: 28.2,
    width: 32.71,
    height: 36.35,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.542
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.395,
    y: 46.375
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.75,
    y: 28.2,
    width: 33.48,
    height: 36.35,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.696
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 101.49,
    y: 46.375
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.24,
    y: 28.2,
    width: 33.75,
    height: 36.35,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.821428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.115,
    y: 46.375
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.99,
    y: 28.2,
    width: 33.92,
    height: 36.35,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.768888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 168.95000000000002,
    y: 46.375
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.91,
    y: 28.2,
    width: 34.19,
    height: 36.35,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.698333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 203.005,
    y: 46.375
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.09,
    y: 28.2,
    width: 34.27,
    height: 36.35,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.895714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 237.225,
    y: 46.375
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 254.36,
    y: 28.2,
    width: 35.21,
    height: 36.35,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.042
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 271.96500000000003,
    y: 46.375
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.57,
    y: 28.2,
    width: 35.37,
    height: 36.35,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.895
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307.255,
    y: 46.375
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324.94,
    y: 28.2,
    width: 35.59,
    height: 36.35,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.8975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 342.735,
    y: 46.375
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 360.53,
    y: 28.2,
    width: 35.65,
    height: 36.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.0928571428571425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 378.35499999999996,
    y: 46.375
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396.18,
    y: 28.2,
    width: 36.06,
    height: 36.35,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.010000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 414.21000000000004,
    y: 46.375
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 432.24,
    y: 28.2,
    width: 36.58,
    height: 36.35,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.192857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 450.53000000000003,
    y: 46.375
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.82,
    y: 28.2,
    width: 37.6,
    height: 36.35,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.192857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 487.62,
    y: 46.375
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 506.43,
    y: 28.2,
    width: 37.83,
    height: 36.35,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.058333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 525.345,
    y: 46.375
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 544.26,
    y: 28.2,
    width: 38.19,
    height: 36.35,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.058333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 563.355,
    y: 46.375
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 582.46,
    y: 28.2,
    width: 38.49,
    height: 36.35,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.2700000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 601.705,
    y: 46.375
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620.95,
    y: 28.2,
    width: 38.95,
    height: 36.35,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.54375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 640.4250000000001,
    y: 46.375
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 659.9,
    y: 28.2,
    width: 40.1,
    height: 36.35,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.2700000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 679.9499999999999,
    y: 46.375
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.04,
    y: 64.55,
    width: 41.04,
    height: 35.66,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.9433333333333325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 72.56,
    y: 82.38
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.04,
    y: 100.21,
    width: 41.04,
    height: 35.86,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.122857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 72.56,
    y: 118.13999999999999
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.04,
    y: 136.07,
    width: 41.04,
    height: 35.89,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.48625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 72.56,
    y: 154.015
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.04,
    y: 171.96,
    width: 41.04,
    height: 36.24,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.177142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 72.56,
    y: 190.08
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.04,
    y: 208.2,
    width: 41.04,
    height: 37.44,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.16
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 72.56,
    y: 226.92
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.04,
    y: 245.63,
    width: 41.04,
    height: 38.33,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.388333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 72.56,
    y: 264.795
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.04,
    y: 283.96,
    width: 41.04,
    height: 38.93,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.86625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 72.56,
    y: 303.42499999999995
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.04,
    y: 322.89,
    width: 41.04,
    height: 39.26,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.6085714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 72.56,
    y: 342.52
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.04,
    y: 362.15,
    width: 41.04,
    height: 39.81,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.962000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 72.56,
    y: 382.05499999999995
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.04,
    y: 401.96,
    width: 41.04,
    height: 40.39,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.487777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 72.56,
    y: 422.155
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.04,
    y: 442.35,
    width: 41.04,
    height: 40.64,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.08
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 72.56,
    y: 462.67
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.04,
    y: 482.99,
    width: 41.04,
    height: 41.92,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.56
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 72.56,
    y: 503.95
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.04,
    y: 524.9,
    width: 41.04,
    height: 43.1,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.13
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 72.56,
    y: 546.4499999999999
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.04,
    y: 568,
    width: 41.04,
    height: 43.74,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.84
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 72.56,
    y: 589.87
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.04,
    y: 611.74,
    width: 41.04,
    height: 43.89,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.208
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 72.56,
    y: 633.6850000000001
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.04,
    y: 655.64,
    width: 41.04,
    height: 44.36,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.13
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 72.56,
    y: 677.8199999999999
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.08,
    y: 64.55,
    width: 42.6,
    height: 43.31,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.38,
    y: 86.205
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.68,
    y: 64.55,
    width: 43.87,
    height: 43.31,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.218333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.615,
    y: 86.205
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.55,
    y: 64.55,
    width: 44.44,
    height: 43.31,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.187142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 201.77,
    y: 86.205
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.99,
    y: 64.55,
    width: 44.5,
    height: 43.31,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.662
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 246.24,
    y: 86.205
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 268.49,
    y: 64.55,
    width: 44.76,
    height: 43.31,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.331
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 290.87,
    y: 86.205
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313.24,
    y: 64.55,
    width: 44.86,
    height: 43.31,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.41375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 335.67,
    y: 86.205
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358.11,
    y: 64.55,
    width: 45.71,
    height: 43.31,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.218333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 380.96500000000003,
    y: 86.205
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 403.82,
    y: 64.55,
    width: 45.94,
    height: 43.31,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.218333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 426.78999999999996,
    y: 86.205
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 449.76,
    y: 64.55,
    width: 49.6,
    height: 43.31,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.218333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 474.56,
    y: 86.205
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.35,
    y: 64.55,
    width: 49.72,
    height: 43.31,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.331
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 524.21,
    y: 86.205
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 549.07,
    y: 64.55,
    width: 50.03,
    height: 43.31,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.187142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 574.085,
    y: 86.205
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 599.11,
    y: 64.55,
    width: 50.37,
    height: 43.31,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.218333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 624.295,
    y: 86.205
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 649.48,
    y: 64.55,
    width: 50.52,
    height: 43.31,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.662
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 674.74,
    y: 86.205
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.08,
    y: 107.87,
    width: 51.35,
    height: 44.06,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.015
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.755,
    y: 129.9
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.08,
    y: 151.92,
    width: 51.35,
    height: 44.72,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.388571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.755,
    y: 174.27999999999997
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.08,
    y: 196.64,
    width: 51.35,
    height: 47.14,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.8925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.755,
    y: 220.20999999999998
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.08,
    y: 243.78,
    width: 51.35,
    height: 47.16,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.431999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.755,
    y: 267.36
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.08,
    y: 290.94,
    width: 51.35,
    height: 47.27,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.878333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.755,
    y: 314.575
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.08,
    y: 338.2,
    width: 51.35,
    height: 49.11,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.185
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.755,
    y: 362.755
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.08,
    y: 387.31,
    width: 51.35,
    height: 50.19,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.038
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.755,
    y: 412.405
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.08,
    y: 437.5,
    width: 51.35,
    height: 50.89,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.7225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.755,
    y: 462.945
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.08,
    y: 488.4,
    width: 51.35,
    height: 51.01,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.2871428571428565
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.755,
    y: 513.905
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.08,
    y: 539.41,
    width: 51.35,
    height: 52.36,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.558333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.755,
    y: 565.5899999999999
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.08,
    y: 591.77,
    width: 51.35,
    height: 53.9,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.755,
    y: 618.72
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.08,
    y: 645.67,
    width: 51.35,
    height: 54.33,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.41875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.755,
    y: 672.8349999999999
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.44,
    y: 107.87,
    width: 46.66,
    height: 61.89,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.6657142857142855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 167.76999999999998,
    y: 138.815
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.1,
    y: 107.87,
    width: 48.72,
    height: 61.89,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.96
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 215.45999999999998,
    y: 138.815
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 239.82,
    y: 107.87,
    width: 49.43,
    height: 61.89,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.238333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.53499999999997,
    y: 138.815
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.25,
    y: 107.87,
    width: 51.33,
    height: 61.89,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.332857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 314.915,
    y: 138.815
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.58,
    y: 107.87,
    width: 52.94,
    height: 61.89,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.6175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 367.04999999999995,
    y: 138.815
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 393.52,
    y: 107.87,
    width: 56.13,
    height: 61.89,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.0325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 421.585,
    y: 138.815
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 449.64,
    y: 107.87,
    width: 59.76,
    height: 61.89,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.959999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 479.52,
    y: 138.815
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.4,
    y: 107.87,
    width: 60.07,
    height: 61.89,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.50875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 539.435,
    y: 138.815
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 569.47,
    y: 107.87,
    width: 64.09,
    height: 61.89,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.84142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 601.515,
    y: 138.815
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 633.56,
    y: 107.87,
    width: 66.44,
    height: 61.89,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.84142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 666.78,
    y: 138.815
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.44,
    y: 169.76,
    width: 78.85,
    height: 54.67,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.111666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 183.865,
    y: 197.095
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.44,
    y: 224.43,
    width: 78.85,
    height: 55.22,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.044
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 183.865,
    y: 252.04000000000002
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.44,
    y: 279.66,
    width: 78.85,
    height: 55.48,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.925714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 183.865,
    y: 307.40000000000003
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.44,
    y: 335.14,
    width: 78.85,
    height: 55.97,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.2188888888888885
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 183.865,
    y: 363.125
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.44,
    y: 391.1,
    width: 78.85,
    height: 66.05,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.209999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 183.865,
    y: 424.125
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.44,
    y: 457.15,
    width: 78.85,
    height: 69.66,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.415
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 183.865,
    y: 491.97999999999996
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.44,
    y: 526.81,
    width: 78.85,
    height: 85.61,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.264285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 183.865,
    y: 569.6149999999999
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.44,
    y: 612.42,
    width: 78.85,
    height: 87.58,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.761111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 183.865,
    y: 656.2099999999999
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.28,
    y: 169.76,
    width: 70.63,
    height: 104,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.771666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.595,
    y: 221.76
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 293.91,
    y: 169.76,
    width: 75.87,
    height: 104,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.174000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 331.845,
    y: 221.76
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 369.78,
    y: 169.76,
    width: 84.8,
    height: 104,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.6
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 412.17999999999995,
    y: 221.76
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 454.57,
    y: 169.76,
    width: 110.32,
    height: 104,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.857142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 509.73,
    y: 221.76
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 564.9,
    y: 169.76,
    width: 135.1,
    height: 104,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 632.4499999999999,
    y: 221.76
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.28,
    y: 273.77,
    width: 123.65,
    height: 124.14,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.45625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 285.105,
    y: 335.84
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.28,
    y: 397.91,
    width: 123.65,
    height: 127.25,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 30.9125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 285.105,
    y: 461.535
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.28,
    y: 525.16,
    width: 123.65,
    height: 174.84,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 30.9125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 285.105,
    y: 612.5799999999999
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 346.93,
    y: 273.77,
    width: 100.18,
    height: 224.07,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.311428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 397.02,
    y: 385.80499999999995
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 447.11,
    y: 273.77,
    width: 252.89,
    height: 224.07,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 37.345
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 573.5550000000001,
    y: 385.80499999999995
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 346.93,
    y: 497.83,
    width: 353.07,
    height: 202.17,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 33.695
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 523.465,
    y: 598.915
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1972);
export default __webpack_public_path__ + "static/media/1972.769a783f98d2cdc07a714bf650fefd31.svg";
export { ForwardRef as ReactComponent };